import React, { useState } from "react";
import { Stepper, 
  Step, 
  StepLabel, 
  Button, 
  Box, 
  Typography, 
  Stack } from "@mui/material";
import { usePricing } from "../../contexts/PricingContext";
import EditableList from "../../components/Custom/EditableList";
import {etapasProjeto,
        opcoesAcompanhamentoObras,
        opcoesAnteprojeto,
        opcoesCustosAdicionais,
        opcoesEstudoPreliminar,
        opcoesLevantamento,
        opcoesProjetoExecutivo,
        opcoesProjetoLegal,
        opcoesVendas      
      } from "../../constants/opcoesPricing";
import StepDadosCliente from "./StepDadosCliente";
import EditableTaskList from "../../components/Custom/EditableTaskList"
import {savePricingStepper2Data} from "../../services/pricingService"
import { useCompany } from "../../contexts/CompanyContext"

import PropTypes from "prop-types";

const StepperEtapa2 = ({ onFinish }) => {
  const [activeStep, setActiveStep] = useState(0);
  const { formData, updateFormData } = usePricing();
  const [error, setError] = useState("");
  const {company} = useCompany()

  const steps = etapasProjeto[formData.tipoProjeto] || ["Introdução", "Dados do Cliente", "Custos Adicionais"];
  
  const handleNext = () => {
    setError(""); 
    if (activeStep === steps.length - 1) {
      savePricingStepper2Data(company,formData)
      .then((pricingId) => {
        formData.id= pricingId
      })
      onFinish();
    } else if (activeStep === 1) {
      const validationMsg = validateStepDadosCliente();
      if (validationMsg) {
        setError(validationMsg);
        return; 
      }
    }
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));

  function validateStepDadosCliente() {
    let error = ''
    if (!formData.dadosCliente?.name) {
      error+= "Selecione um cliente.\n";
    }
    if (!formData?.nomeProjeto || formData.nomeProjeto.trim() === "") {
      error+= "Informe o nome do projeto.\n";
    }
    if (!formData.tipoProjeto || formData.tipoProjeto.trim() === "") {
      error+= "Selecione o tipo de projeto.\n";
    }
    return error;
  }

  return (
    <Box sx={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column" }}>
      <Box sx={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        background: "#fff",
        pb: 2,
        pt: 4,
        px: 3,
        borderBottom: "1px solid #eee"
      }}>
        <Typography variant="h6" gutterBottom>Etapa 2 - Custos do projeto</Typography>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      <Box sx={{
        flex: 1,
        overflowY: "auto",
        px: 3,
        pt: 4
      }}>
        {activeStep === 0 && (
          <Typography>
            Mussum Ipsum, cacilds vidis litro abertis.  A ordem dos tratores não altera 
            o pão duris. Praesent malesuada urna nisi, quis volutpat erat hendrerit non. 
            Nam vulputate dapibus. Morbi viverra placerat justo, vel pharetra turpis. Si 
            num tem leite então bota uma pinga aí cumpadi!

            Nec orci ornare consequat. Praesent lacinia ultrices consectetur. Sed non 
            ipsum felis. Praesent vel viverra nisi. Mauris aliquet nunc non turpis 
            scelerisque, eget. Nulla id gravida magna, ut semper sapien. Viva Forevis 
            aptent taciti sociosqu ad litora torquent. 
          </Typography>

        )}

        {activeStep === 1 && (
          <>
            <StepDadosCliente formData={formData} updateFormData={updateFormData} />
            {error && (
              <Typography color="error" sx={{ mt: 2, textAlign: 'center', whiteSpace: 'pre-line' }}>
                {error}
              </Typography>
            )}
          </>
        )}

        {activeStep === steps.indexOf("Venda") && (
          <EditableTaskList
            key="Venda"
            items={formData.venda}
            onChange={next => updateFormData("venda", next)}
            funcionarios={formData.funcionarios || []}
            itensDescricao={opcoesVendas}
          />
        )}

        {activeStep === steps.indexOf("Levantamento") && (
          
          <EditableTaskList
            key="Levantamento"
            items={formData.levantamento}
            onChange={next => updateFormData("levantamento", next)}
            funcionarios={formData.funcionarios || []}
            itensDescricao={opcoesLevantamento[formData.tipoProjeto] || []}
          />
        )}

        {activeStep === steps.indexOf("Estudo Preliminar") && (
          <EditableTaskList
            key="estudoPreliminar"
            items={formData.estudoPreliminar}
            onChange={next => updateFormData("estudoPreliminar", next)}
            funcionarios={formData.funcionarios || []}
            itensDescricao={opcoesEstudoPreliminar[formData.tipoProjeto]||[]}
          />
        )}

        {activeStep === steps.indexOf("Anteprojeto") && (
          <EditableTaskList
            key="anteprojeto"
            items={formData.anteprojeto}
            onChange={next => updateFormData("anteprojeto", next)}
            funcionarios={formData.funcionarios || []}
            itensDescricao={opcoesAnteprojeto[formData.tipoProjeto]||[]}
          />
        )}

        {activeStep === steps.indexOf("Projeto Legal") && (
          <EditableTaskList
            key="projetoLegal"
            items={formData.projetoLegal}
            onChange={next => updateFormData("projetoLegal", next)}
            funcionarios={formData.funcionarios || []}
            itensDescricao={opcoesProjetoLegal[formData.tipoProjeto]||[]}
          />
        )}

        {activeStep === steps.indexOf("Projeto Executivo") && (
          <EditableTaskList
            key="projetoExecutivo"
            items={formData.projetoExecutivo}
            onChange={next => updateFormData("projetoExecutivo", next)}
            funcionarios={formData.funcionarios || []}
            itensDescricao={opcoesProjetoExecutivo[formData.tipoProjeto]||[]}
          />
        )}

        {activeStep === steps.indexOf("Acompanhamento de Obra") && (
          <EditableTaskList
            key="acompanhamentoObra"
            items={formData.acompanhamentoObra}
            onChange={next => updateFormData("acompanhamentoObra", next)}
            funcionarios={formData.funcionarios || []}
            itensDescricao={opcoesAcompanhamentoObras[formData.tipoProjeto]||[]}
          />
        )}


        {activeStep === steps.indexOf("Custos Adicionais") && (
          <EditableList
            items={formData.custosAdicionais}
            onChange={(next) => updateFormData("custosAdicionais", next)}
            descricaoLabel="Descrição do custo adicional"
            valorLabel="Valor"
            descricaoMode="autocomplete"
            descricaoOptions={opcoesCustosAdicionais}
            descricaoFreeSolo
          />
        )}
        <Stack direction="row" spacing={2} mt={3}>
          <Button variant="outlined" onClick={handleBack} disabled={activeStep === 0}>Voltar</Button>
          <Button variant="contained" onClick={handleNext}>
            {activeStep === steps.length - 1 ? "Concluir Precificação" : "Próximo"}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

StepperEtapa2.propTypes = {
  onFinish: PropTypes.object.isRequired
};

export default StepperEtapa2;